/*
 *
 * @desc: 产品页主图缩略图配置
 *        根据语言筛选 -> 根据国家地区筛选/默认配置
 * @author: haifn
 * @time: 2019/10/9 11:28
 *
 */
import { LANG, getCountryCode, getLang, isEmpty } from '../index';

const base = 'https://static.insta360.com/assets/www/project/store/product/displays';

// 按顺序替换其中N张
const displaysConfig = {
  411: {
    zh_name: '自拍杆',
    desc: '日本自拍杆版权问题永久更换产品图（日本地区）',
    LANGS: {
      'ja_jp': {
        'JP': [
          {
            l: base + '/selfie_stick/411_onex_selfie_stick/jp_01_600x600.jpg',
            sm: base + '/selfie_stick/411_onex_selfie_stick/jp_01_80x80.jpg',
          },
          {
            l: base + '/selfie_stick/411_onex_selfie_stick/jp_02_600x600.jpg',
            sm: base + '/selfie_stick/411_onex_selfie_stick/jp_02_80x80.jpg',
          },
        ],
        default: null,
      },
    },
  },
  1168: {
    zh_name: 'ONEX2火影鸣人版本',
    desc: '日本',
    LANGS: {
      'ja_jp': {
        'JP': [
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/6236a159cad11294536504962733ffdc/naruto_01_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/6236a159cad11294536504962733ffdc/naruto_01_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/fda107b6c1a3391a8b5a5d37e1c1d3ae/naruto_02_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/fda107b6c1a3391a8b5a5d37e1c1d3ae/naruto_02_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/b8f66d8d58adc2acb838fda35fadd8a6/naruto_03_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/b8f66d8d58adc2acb838fda35fadd8a6/naruto_03_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/3edf17e567f1c058c9133e4df726b423/naruto_04_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/3edf17e567f1c058c9133e4df726b423/naruto_04_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/1ada5a782ef03aa85ed9e9eb4566296f/naruto_05_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/1ada5a782ef03aa85ed9e9eb4566296f/naruto_05_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/f3b6e7fdb9d125e62ecb34b53e2d99cf/naruto_06_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/f3b6e7fdb9d125e62ecb34b53e2d99cf/naruto_06_780w.png',
          },
        ],
        default: null,
      },
    },
  },
  1174: {
    zh_name: 'ONEX2火影佐助版本',
    desc: '日本',
    LANGS: {
      'ja_jp': {
        'JP': [
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/3a9ee9d0e2721075493c47c9e9e25d42/sasuke_01_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/3a9ee9d0e2721075493c47c9e9e25d42/sasuke_01_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/c738e4a52836fd2b91b47e5965732b2f/sasuke_02_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/c738e4a52836fd2b91b47e5965732b2f/sasuke_02_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/5631335f9cc95d63db9c00e93ab49f52/sasuke_03_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/5631335f9cc95d63db9c00e93ab49f52/sasuke_03_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/16b2b88f26658984452d3e98ba8b219d/sasuke_04_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/16b2b88f26658984452d3e98ba8b219d/sasuke_04_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/f97fb771a28e6080a8b39dc4e82af43e/sasuke_05_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/f97fb771a28e6080a8b39dc4e82af43e/sasuke_05_780w.png',
          },
          {
            l: 'https://res.insta360.com/static/assets/storage/20201103/4c3ce9d482001a20e1319c24cd2ed56b/sasuke_06_780w.png',
            sm: 'https://res.insta360.com/static/assets/storage/20201103/4c3ce9d482001a20e1319c24cd2ed56b/sasuke_06_780w.png',
          },
        ],
        default: null,
      },
    },
  },
  1122: {
    zh_name: '1英寸徕卡版本-潜水套餐',
    desc: '赠送浅水壳',
    LANGS: {
      'zh_cn': {
        default: [
          {
            l: 'https://res.insta360.com/static/80a103b3ba009eeb5d913ad87cee65c9/1122CN-780.png',
            sm: 'https://res.insta360.com/static/971cfd39772230086dd8953655cd0736/1122CN-80.png',
          },
        ],
      },
      'de_de': {
        default: [
          {
            l: 'https://res.insta360.com/static/ec057bb5e7dfe2d77c20280ccba60e3e/1122DE-780.png',
            sm: 'https://res.insta360.com/static/a137d107b4c14d1def6fbeb713648608/1122DE-80.png',
          },
        ],
      },
      'en_us': {
        default: [
          {
            l: 'https://res.insta360.com/static/c3b576127cc3af00422d19bbd6969f24/1122EN-780.png',
            sm: 'https://res.insta360.com/static/1b49bfd9065161e6ac5edbee6455dcfe/1122EN-80.png',
          },
        ],
      },
      'es_es': {
        default: [
          {
            l: 'https://res.insta360.com/static/5b3bd56c7c00db3fc434e67eac4ab412/1122ES-780.png',
            sm: 'https://res.insta360.com/static/fce3ceed136595f0737bef23e86f21f9/1122ES-80.png',
          },
        ],
      },
      'fr_fr': {
        default: [
          {
            l: 'https://res.insta360.com/static/bce1f27e3f03e5c35f8bf618a01f8509/1122FR-780.png',
            sm: 'https://res.insta360.com/static/e68114db48f63165509a59b646a2a5a1/1122FR-80.png',
          },
        ],
      },
      'it_it': {
        default: [
          {
            l: 'https://res.insta360.com/static/834530b4c6cbb162d8fee50c587ee9d7/1122IT-780.png',
            sm: 'https://res.insta360.com/static/9b35dea08a06f80575b31c0f63974534/1122IT-80.png',
          },
        ],
      },
      'ja_jp': {
        default: [
          {
            l: 'https://res.insta360.com/static/c2cf1f0b376c050580b2f3b98048e603/1122JP-780.png',
            sm: 'https://res.insta360.com/static/0ab3f89068c7dd8244ad6c66377f2d0b/1122JP-80.png',
          },
        ],
      },
      'ko_kr': {
        default: [
          {
            l: 'https://res.insta360.com/static/8c0d98228b5ad6bc7df9da06e085871c/1122KR-780.png',
            sm: 'https://res.insta360.com/static/3541545f6b982cf82f45eb228ebcd518/1122KR-80.png',
          },
        ],
      },
      'zh_tw': {
        default: [
          {
            l: 'https://res.insta360.com/static/42951fbe31e6e66d56223850cf1d766f/1122TC-780.png',
            sm: 'https://res.insta360.com/static/bbddfa92fa1fc87925a2a7210c8fce95/1122TC-80.png',
          },
        ],
      },
    },
  },
  1550: {
    zh_name: '尊享版套餐（潜水壳）',
    desc: '赠送浅水壳',
    LANGS: {
      'zh_cn': {
        default: [
          {
            l: 'https://res.insta360.com/static/c802845b52a58bb346b5c15c0b70b08b/1550CN-780.png',
            sm: 'https://res.insta360.com/static/808830a8eef1a1f00170cddd0beb874a/1550CN-80.png',
          },
        ],
      },
      'de_de': {
        default: [
          {
            l: 'https://res.insta360.com/static/2a48054c5baa910c6821b3e41624d9c5/1550DE-780.png',
            sm: 'https://res.insta360.com/static/0c7fd51774c6974d9688de8848f042cd/1550DE-80.png',
          },
        ],
      },
      'en_us': {
        default: [
          {
            l: 'https://res.insta360.com/static/9ade0b67215dfce7e020c658f5532d38/1550EN-780.png',
            sm: 'https://res.insta360.com/static/cd72a6ddb17422761a20a54d6a7a2fd7/1550EN-80.png',
          },
        ],
      },
      'es_es': {
        default: [
          {
            l: 'https://res.insta360.com/static/2af59b9c0d1d95afe599a0a1a39cffd1/1550ES-780.png',
            sm: 'https://res.insta360.com/static/26cc5b10e103dc6b7d35cad13da26b54/1550ES-80.png',
          },
        ],
      },
      'fr_fr': {
        default: [
          {
            l: 'https://res.insta360.com/static/d92a87f82c2ab5c75d543f0d9da874a4/1550FR-780.png',
            sm: 'https://res.insta360.com/static/9b44630a47229b2562472536b2277136/1550FR-80.png',
          },
        ],
      },
      'it_it': {
        default: [
          {
            l: 'https://res.insta360.com/static/b48016f7e80078bc81a9cb5caae58b11/1550IT_-780.png',
            sm: 'https://res.insta360.com/static/a7b55d0be97f3bc5790ac4b99d7d6b37/1550IT-80.png',
          },
        ],
      },
      'ja_jp': {
        default: [
          {
            l: 'https://res.insta360.com/static/4a458ca4599228d96b0524e2e9ad4158/1550JP-780.png',
            sm: 'https://res.insta360.com/static/7664e31865c479f079f27ba835f105a7/1550JP-80.png',
          },
        ],
      },
      'ko_kr': {
        default: [
          {
            l: 'https://res.insta360.com/static/07aa84ecf5b42000cc30f9c9fbc32461/1550KR-780.png',
            sm: 'https://res.insta360.com/static/4676e9f8d13ad6f630441c8ea0bf304a/1550KR-80.png',
          },
        ],
      },
      'zh_tw': {
        default: [
          {
            l: 'https://res.insta360.com/static/25a08a29dba56fbcf1188aef23c06708/1550TC-780.png',
            sm: 'https://res.insta360.com/static/d9ab4f8c60526e69f8b03d2563ceb60c/1550TC-80.png',
          },
        ],
      },
    },
  },
  2118: {
    zh_name: 'x3标准套餐',
    desc: '明星代言图',
    disabled: true,
    LANGS: {
      'zh_cn': {
        'CN': [
          {
            l: 'https://res.insta360.com/static/101a3290dfd490d30e9fef2b9c22c5db/%E6%A0%87%E9%85%8D.png',
            sm: 'https://res.insta360.com/static/c7ca17221ccd712016bb49f6c1fb331e/%E6%A0%87%E9%85%8D-1.png',
            index: 1,
          },
        ],
        default: null,
      },
    },
  },
  2106: {
    zh_name: 'x3滑雪套餐',
    desc: '明星代言图',
    disabled: true,
    LANGS: {
      'zh_cn': {
        'CN': [
          {
            l: 'https://res.insta360.com/static/b9c62d6f11e5dd483abd07a46f7c1373/%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%90.png',
            sm: 'https://res.insta360.com/static/e6ad193c0bc21fe8d97fca8a1391d2a5/%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%90-1.png',
          },
          {
            l: 'https://res.insta360.com/static/4358d50706e4b0eb0b183d7962ff20ba/%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%90-%E5%B9%B3%E9%93%BA.png',
            sm: 'https://res.insta360.com/static/a39d89e42bf895821f094497413e8597/%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%90-%E5%B9%B3%E9%93%BA-1.png',
          },
        ],
        default: null,
      },
    },
  },
  1742: {
    zh_name: 'one_rs双镜头标准套餐',
    desc: '明星代言图',
    disabled: true,
    LANGS: {
      'zh_cn': {
        'CN': [
          {
            l: 'https://res.insta360.com/static/ee66fb2f94887faa538dedfdd1a9134b/RS-%E5%8F%8C%E9%95%9C%E5%A4%B4.png',
            sm: 'https://res.insta360.com/static/dfa67d337c5b1ee78834a9d189ba1efe/RS-%E5%8F%8C%E9%95%9C%E5%A4%B4-1.png',
            index: 2,
          },
        ],
        default: null,
      },
    },
  },
  1744: {
    zh_name: 'one_rs双镜头滑雪套餐',
    desc: '明星代言图',
    disabled: true,
    LANGS: {
      'zh_cn': {
        'CN': [
          {
            l: 'https://res.insta360.com/static/7ae43317add351328fb2bcb5441d256c/RS-%E5%8F%8C%E9%95%9C%E5%A4%B4%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%900.png',
            sm: 'https://res.insta360.com/static/d806b6dee81611a8004e1cae67bfc33c/RS-%E5%8F%8C%E9%95%9C%E5%A4%B4%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%900-1.png',
            index: 1,
          },
          {
            l: 'https://res.insta360.com/static/1abff15ecae5440be8f8008c8d206e0e/RS-%E5%8F%8C%E9%95%9C%E5%A4%B4-%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%903.png',
            sm: 'https://res.insta360.com/static/05641cd370d4b64ba1c787eae24fb593/RS-%E5%8F%8C%E9%95%9C%E5%A4%B4-%E6%BB%91%E9%9B%AA%E5%A5%97%E9%A4%903-1.png',
            index: 3,
          },
        ],
        default: null,
      },
    },
  },
  1980: {
    zh_name: 'link标准套餐',
    desc: 'link-钉钉',
    LANGS: {
      'zh_cn': {
        'CN': [
          {
            l: 'https://res.insta360.com/static/de467510a5c7e455069518c38e2162b9/1.png',
            index: 1,
          },
          {
            l: 'https://res.insta360.com/static/20ba333ac469ac1f18f1e7501475561f/2.png',
            index: 2,
          },
          {
            l: 'https://res.insta360.com/static/f0eaa5d38afeb8ad0d0c4553ea60f573/3.png',
            index: 3,
          },
          {
            l: 'https://res.insta360.com/static/ebdd9d7b5f03af1a3a57848500246f25/4.png',
            index: 4,
          },
          {
            l: 'https://res.insta360.com/static/e1f8abdae51d6ef88b0087f48cf89868/5.png',
            index: 5,
          },
          {
            l: 'https://res.insta360.com/static/e4c40423068dc774a9f572c998b6d55a/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90.png',
            index: 6,
          },
        ],
        default: null,
      },
    },
  },
  1982: {
    zh_name: 'link迷你脚架套餐',
    desc: 'link-钉钉',
    LANGS: {
      'zh_cn': {
        'CN': [
          {
            l: 'https://res.insta360.com/static/9fb3694ff1dab701beb51efde17621a4/%E4%BA%BA%E6%B0%94%E5%A5%97%E9%A4%90.png',
            index: 1,
          },
        ],
        default: null,
      },
    },
  },
};

// 完全替换主图配置
const displaysReplaceConfig = {
  2358: {
    desc: 'X3鬼灭弥豆子版本(无内存卡) 中国',
    LANGS: {
      'zh_cn': {
        default: [
          {
            l: 'https://res.insta360.com/static/77eb3d6fe6cabe676e2774b76e77632c/01.png',
            sm: 'https://res.insta360.com/static/bbc6d76ea938a9a32fa9491e5b148b7b/01-1.png',
          },
          {
            l: 'https://res.insta360.com/static/8e99eb749e1bab818c70b5bbfee7088b/02.png',
            sm: 'https://res.insta360.com/static/d6d4e5de02da223bb9e1c65c9c8e086a/02-1.png',
          },
          {
            l: 'https://res.insta360.com/static/e2ab4ace4af91bef2882ae9bd9a12987/03.png',
            sm: 'https://res.insta360.com/static/e46a2fd80f91189f56266122ec405c79/03-1.png',
          },
          {
            l: 'https://res.insta360.com/static/c303ddb08845ded9015bc68a10dfdfb9/04.png',
            sm: 'https://res.insta360.com/static/0c7225f9903384691bb342b7698dbfdd/04-1.png',
          },
          {
            l: 'https://res.insta360.com/static/5b71276c10e91d6ee899b4cbfc5fe07d/05.png',
            sm: 'https://res.insta360.com/static/045f4de6a22ddc77ecb9c173976d9ede/05-1.png',
          },
          {
            l: 'https://res.insta360.com/static/62caad356f581c4c6e5415d546ce9c32/06.png',
            sm: 'https://res.insta360.com/static/cdbf272e4f0f51a9c54b2f594485ceb2/06-1.png',
          },
        ],
      },
    },
  },
  2359: {
    desc: 'X3鬼灭弥豆子版本(64G内存卡) 中国',
    LANGS: {
      'zh_cn': {
        default: [
          {
            l: 'https://res.insta360.com/static/6821bd8deaac6638edb12178c874d5f8/%E7%A5%A2%E8%B1%86%E5%AD%90-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9064G.png',
            sm: 'https://res.insta360.com/static/bf95b1abe7d62768d6090ba32681b620/%E7%A5%A2%E8%B1%86%E5%AD%90-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9064G-1.png',
          },
        ],
      },
    },
  },
  2360: {
    desc: 'X3鬼灭弥豆子版本(128G内存卡) 中国',
    LANGS: {
      'zh_cn': {
        default: [
          {
            l: 'https://res.insta360.com/static/bd9ccb2c60bbf692c262d9f29e3fb099/%E7%A5%A2%E8%B1%86%E5%AD%90-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90128G.png',
            sm: 'https://res.insta360.com/static/378a07475ce1b7035fb74a78568ec35b/%E7%A5%A2%E8%B1%86%E5%AD%90-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90128G-1.png',
          },
        ],
      },
    },
  },
  2361: {
    desc: 'X3鬼灭炭治郎版本(无内存卡) 中国',
    LANGS: {
      'zh_cn': {
        default: [
          {
            l: 'https://res.insta360.com/static/41f280dc5ebab8c1f8c2bba8fe5cdce7/01.png',
            sm: 'https://res.insta360.com/static/83236730573f5ecd66ce4b3e0b2b67fb/01-1.png',
          },
          {
            l: 'https://res.insta360.com/static/af6a6b5f6438cacbc869df9e613a1914/02.png',
            sm: 'https://res.insta360.com/static/733fef4c7c6ad13b6762f4f3fadb3b85/02-1.png',
          },
          {
            l: 'https://res.insta360.com/static/c2496453f5b057e411337843c995ec9e/03.png',
            sm: 'https://res.insta360.com/static/8c217663e72015eafa780e5eeadbbf18/03-1.png',
          },
          {
            l: 'https://res.insta360.com/static/bb5453598b2e7da1ca0443b077927498/04.png',
            sm: 'https://res.insta360.com/static/744892332c5fb03291cfa3b40d1c5b7f/04-1.png',
          },
          {
            l: 'https://res.insta360.com/static/f42fc5abd18b219c1c33012946687caf/05.png',
            sm: 'https://res.insta360.com/static/a481ee5986891b37d1aab77a1f12c1e2/05-1.png',
          },
          {
            l: 'https://res.insta360.com/static/d68186e06abf289c1c898ee6bece1ef1/06.png',
            sm: 'https://res.insta360.com/static/16467e99a414fa1a2c310a10a08974f7/06-1.png',
          },
        ],
      },
    },
  },
  2362: {
    desc: 'X3鬼灭炭治郎版本(64G内存卡) 中国',
    LANGS: {
      'zh_cn': {
        default: [
          {
            l: 'https://res.insta360.com/static/84f451a268bf616a2e2328a2271129e9/%E7%82%AD%E6%B2%BB%E9%83%8E-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9064G.png',
            sm: 'https://res.insta360.com/static/73d2ce9e19de2623bc934fe54cdb5104/%E7%82%AD%E6%B2%BB%E9%83%8E-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9064G-1.png',
          },
        ],
      },
    },
  },
  2363: {
    desc: 'X3鬼灭炭治郎版本(128G内存卡) 中国',
    LANGS: {
      'zh_cn': {
        default: [
          {
            l: 'https://res.insta360.com/static/1c0b881360b93af4c1dd11a7db8f8a80/%E7%82%AD%E6%B2%BB%E9%83%8E-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90128G.png',
            sm: 'https://res.insta360.com/static/560a0fcc1f30a2dbeec1422e8590afb1/%E7%82%AD%E6%B2%BB%E9%83%8E-%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90128G-1.png',
          },
        ],
      },
    },
  },
  1168: {
    desc: 'ONEX2火影鸣人版本 中国台湾、中国香港替换',
    LANGS: {
      'zh_tw': {
        default: [
          {
            l: 'https://res.insta360.com/static/d2b765752a414729cef067b4dfaf2de4/1168_780.png',
            sm: 'https://res.insta360.com/static/7daafb12b1124a3f642232aec15437f2/1168_80.png',
          },
        ],
      },
      'en_us': {
        'HK': [
          {
            l: 'https://res.insta360.com/static/d2b765752a414729cef067b4dfaf2de4/1168_780.png',
            sm: 'https://res.insta360.com/static/7daafb12b1124a3f642232aec15437f2/1168_80.png',
          },
        ],
      },
    },
  },
  1174: {
    desc: 'ONEX2火影佐助版本 中国台湾、中国香港替换',
    LANGS: {
      'zh_tw': {
        default: [
          {
            l: 'https://res.insta360.com/static/68cba9b8e4b70875888cd6afd0481153/1174_780.png',
            sm: 'https://res.insta360.com/static/c4535939fa294b9b9ba6c6fc9d7ee072/1174_80.png',
          },
        ],
      },
      'en_us': {
        'HK': [
          {
            l: 'https://res.insta360.com/static/68cba9b8e4b70875888cd6afd0481153/1174_780.png',
            sm: 'https://res.insta360.com/static/c4535939fa294b9b9ba6c6fc9d7ee072/1174_80.png',
          },
        ],
      },
    },
  },
};

export function handleDisplays(_displays, area = getCountryCode(), lang = getLang()) {
  if (!_displays || !_displays[0]) return [];
  const displays = JSON.parse(JSON.stringify(_displays));
  const commodity_id = displays[0] && displays[0]['commodity'];
  const commodityConfig = displaysConfig?.[commodity_id];
  let temp = commodityConfig?.disabled ? null : commodityConfig?.LANGS[lang] || commodityConfig?.LANGS['default'];
  let tempReplace = displaysReplaceConfig?.[commodity_id]?.LANGS[lang];
  // 整体替换优先级高于部分替换
  if (tempReplace) {
    const countryConfig = tempReplace?.[area];
    const defaultConfig = tempReplace?.['default'];
    const tempLength = countryConfig?.length || defaultConfig?.length;

    let source = null;
    if (countryConfig || defaultConfig) {
      source = countryConfig || defaultConfig;
    } else {
      return displays;
    }

    source.forEach((o, i) => {
      if (displays[i]) {
        displays[i].url = o.l;
        displays[i].url_m = o.sm;
        displays[i].url_s = o.sm;
      }
    });

    return displays.slice(0, tempLength);
  }
  // 部分替换
  if (temp) {
    if (commodityConfig.filter && commodityConfig.filter.includes(area)) return displays;
    const countryConfig = temp?.[area];
    const defaultConfig = temp?.['default'];
    let source = null;
    if (countryConfig) {
      if (countryConfig.length === 0) {
        return displays;
      } else {
        source = area;
      }
    } else if (defaultConfig) {
      source = 'default';
    } else {
      return displays;
    }
    temp[source].forEach((o, i) => {
      if (displays[i] || displays[o.index - 1]) {
        if (isEmpty(o.index)) {
          displays[i].url = o.l ?? displays[i].url;
          displays[i].url_m = o.sm ?? displays[i].url_m;
          displays[i].url_s = o.sm ?? displays[i].url_s;
        } else {
          if (displays[o.index - 1]) {
            // 防止配置错index的情况
            displays[o.index - 1].url = o.l ?? displays[o.index - 1].url;
            displays[o.index - 1].url_m = o.sm ?? displays[o.index - 1].url_m;
            displays[o.index - 1].url_s = o.sm ?? displays[o.index - 1].url_s;
          }
        }
      } else {
        displays.push({
          url: o.l,
          url_m: o.sm,
          url_s: o.sm,
        });
      }
    });
    return displays;
  }

  return displays;
}
